import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M7 22a5 5 0 0 1-2-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16.93c.96.43 1.96.74 2.99.91", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "LassoSelect";
const LassoSelect = memo(themed(Icon));
export {
  LassoSelect
};
//# sourceMappingURL=lasso-select.js.map
